import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { calcTotalPrice } from './calcTotalPrice.js';

class ProductPageUpsell extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateUpsell);
    
    const upsell_cta = this.querySelector('.upsell_cta');
    upsell_cta?.addEventListener('click', this.#handleUpsellCTA);

    
    const upsell_image = this.querySelector('.img_wrapper img');
    upsell_image?.addEventListener('click', this.#handleToggleDescription);

    
    const upsell_heading = this.querySelector('.upsell_heading');
    upsell_heading?.addEventListener('click', this.#handleToggleDescription);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateUpsell);

    
    const upsell_cta = this.querySelector('.upsell_cta');
    upsell_cta?.removeEventListener('click', this.#handleUpsellCTA);

    const upsell_image = this.querySelector('.img_wrapper img');
    upsell_image?.removeEventListener('click', this.#handleToggleDescription);

    
    const upsell_heading = this.querySelector('.upsell_heading');
    upsell_heading?.removeEventListener('click', this.#handleToggleDescription);
  }

  /**
   * Updates the Upsell.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateUpsell = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newUpsell = event.detail.data.html.querySelector('product-page-upsell');

    if (!newUpsell) return;

    morph(this, newUpsell, { childrenOnly: true });

    // custom added logic
    let productDetails = this.closest('.product-details');
    if (productDetails) {
      // no upsell is added by default
      productDetails.closest('.product-details')?.classList.remove('product_upsell--added');

      // Update the [name="productUpsell"] and [name="productUpsellId"] and [productUpsellQuantity] inside ProductFormComponent
      const  productUpsellCheckbox = productDetails.querySelector('[name="productUpsell"]');
      if (productUpsellCheckbox && productUpsellCheckbox instanceof HTMLInputElement ) { productUpsellCheckbox.checked = false; }

      const  productUpsellId =  productDetails.querySelector('[name="productUpsellId"]')
      const UpsellElement = this.querySelector('.product-upsell__container');
      if (productUpsellId && productUpsellId instanceof HTMLInputElement && UpsellElement instanceof HTMLElement ) { productUpsellId.value = UpsellElement?.dataset?.upsellId ?? ''; }

      const  productUpsellQuantity =  productDetails.querySelector('[name="productUpsellQuantity"]')
      if (productUpsellQuantity && productUpsellQuantity instanceof HTMLInputElement && UpsellElement instanceof HTMLElement ) { productUpsellQuantity.value = UpsellElement?.dataset?.upsellQuantity ?? '1'; }

    }

    calcTotalPrice();


  };

  /**
   * toggles the active class that defines whetlter the upsell is added or not.
   *
   * @param {MouseEvent} event - Thevent mouse event.
   */
  #handleUpsellCTA(event) {
    const target = /** @type {HTMLElement} */ (event.target);
    target?.classList.toggle('active');
    

    const mainProductCTA = this.closest('.product-details')?.querySelector('.add-to-cart-text__content') ;
    const  productUpsellCheckbox = this.closest('.product-details')?.querySelector('[name="productUpsell"]');
    let productContianer = this.closest('.product-information');
    let productHandle = '';
    if (productContianer instanceof HTMLElement) {
      productHandle = productContianer?.dataset?.product ?? '';
    }
    // upsell is added
    if (target?.classList?.contains('active')) {
      // change txt to "Add 2 ITEMS to Cart"
      if (mainProductCTA) {
        if (productHandle =="adjustable-bed") { mainProductCTA.innerHTML = "ADD ITEMS TO CART";}
        else { mainProductCTA.innerHTML = "ADD 2 ITEMS TO CART"; }
      }
      if (productUpsellCheckbox && productUpsellCheckbox instanceof HTMLInputElement) { productUpsellCheckbox.checked = true; }
      target.closest('.product-details')?.classList.add('product_upsell--added');
      let hasFree5 = target.closest('.product-details')?.querySelector('.variant-picker__form')?.classList.contains('variant--with-free5');
      if (hasFree5) {
        let Free5Input = target.closest('.product-details')?.querySelector(".warranty_variants [data-name='adjustable-bed-warranty--5-years']");
        if (Free5Input && Free5Input instanceof HTMLInputElement) { Free5Input?.click(); }
      }
    }else{
      // upsell is removed
      // change txt back to "Add to Cart"
      if (mainProductCTA) { mainProductCTA.innerHTML = "ADD TO CART"; }
      if (productUpsellCheckbox && productUpsellCheckbox instanceof HTMLInputElement ) { productUpsellCheckbox.checked = false; }
      target.closest('.product-details')?.classList.remove('product_upsell--added');
      let hasFree5 = target.closest('.product-details')?.querySelector('.variant-picker__form')?.classList.contains('variant--with-free5');
      if (hasFree5) {
        let default2Input = target.closest('.product-details')?.querySelector(".warranty_variants [data-name='adjustable-bed-warranty--2-years']");
        if (default2Input && default2Input instanceof HTMLInputElement) { default2Input?.click(); }
      }

    }

    // update the total price
    calcTotalPrice();

  }

  /**
   * toggles the active class that defines whetlter the upsell is added or not.
   *    
   *  @param {MouseEvent} event - Thevent mouse event.
  */
  #handleToggleDescription(event) {
    const target = /** @type {HTMLElement} */ (event.target);
    target?.closest('.product-upsell__container')?.querySelector(".upsell_down")?.classList.toggle('open');
  }

}

if (!customElements.get('product-page-upsell')) {
  customElements.define('product-page-upsell', ProductPageUpsell);
}
